import { useQuery } from '@tanstack/react-query';

import { TimeConstants } from '../../../constants/time';
import { StatsigApi } from '../statsig.api';

/**
 * Statsig gate(feature flag) 목록 조회 훅
 * - DevTool에서 gate의 isEnabled + 현재 사용자 평가 결과를 표시하기 위해 사용
 */
const useGatesQuery = () => {
  return useQuery({
    queryKey: StatsigApi.queryKeys.activeGates(),
    queryFn: StatsigApi.findGates,
    staleTime: TimeConstants.FIVE_MINUTES,
  });
};

export default useGatesQuery;
